import { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { ownerApi } from '../api/owner';
import { useAuthStore } from '../stores/authStore';
import type { BusinessSiteType } from '../types';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/profile', label: 'Business Profile' },
  { to: '/products', label: 'Products / Menu' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/insights', label: 'Insights' },
];

export function Layout() {
  const { user, logout } = useAuthStore();
  const [siteType, setSiteType] = useState<BusinessSiteType | null>(null);

  useEffect(() => {
    ownerApi
      .getBusiness()
      .then((b) => setSiteType(b.site_type))
      .catch(() => setSiteType(null));
  }, []);

  const navItems =
    siteType === 'custom_html'
      ? [...NAV_ITEMS, { to: '/html-page', label: 'HTML Page' }]
      : NAV_ITEMS;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-brand bg-brand-primary text-sm font-bold text-white">
              QB
            </span>
            <span className="font-semibold text-slate-800">Owner Portal</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-slate-500 sm:inline">{user?.full_name}</span>
            <button
              onClick={() => void logout()}
              className="rounded-brand border border-slate-200 px-3 py-1.5 text-sm font-medium text-slate-600 transition hover:bg-slate-100"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto flex max-w-6xl gap-6 px-4 py-6">
        <nav className="w-48 shrink-0 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block rounded-brand px-3 py-2 text-sm font-medium transition ${
                  isActive ? 'bg-brand-primary text-white' : 'text-slate-600 hover:bg-slate-100'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <main className="min-w-0 flex-1 space-y-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
